module.exports = __webpack_public_path__ + "static/media/body-bg.043e5f40.png";